import * as React from 'react';
import PageIFrame from '../PageIFrame';
import { makeFrameIDForSinglePage } from '../../../helpers/pages';
import { FrameInfo } from '../../../../../../common/src/ts/types/FrameInfo';
import { UIEventListeners } from '../../../../../../common/src/ts/types/uievent';
import { getGlobalFrameStore } from '../../../services/FrameStore';
import { Rectangle } from 'ark-common';
import SheetScaler, { ScaleBehavior } from '../SheetScaler';
import { UIModeState } from '../../../reducers/uimode';
import { ZoomingParams, SheetLayout } from '../../../utils/view';
import { AppStates } from '../../../reducers/app';
import {
  mapStateToViewTransform,
} from '../../../selectors/zoomingSelector';
import { connect } from 'react-redux';
import { defaultPageIFrameBackgrouncColor } from '../../../constants';

export interface GeneratedReflowablePageOwnProps {
  panelID: string;
  title: string;
  xhtml: string;
  uiEventListeners: UIEventListeners;
  uimode: UIModeState;
}

interface GeneratedReflowablePageProps extends GeneratedReflowablePageOwnProps{
  arrangementInfo: ZoomingParams;
}

const GeneratedReflowablePage: React.SFC<
  GeneratedReflowablePageProps
> = React.memo((props: GeneratedReflowablePageProps) => {
  const { panelID, arrangementInfo } = props;
  if (arrangementInfo.layout !== SheetLayout.Reflowable) {
    throw new Error('Generated content is not reflowable.');
  }

  const frameID = makeFrameIDForSinglePage(panelID);

  const frameInfo: FrameInfo = {
    panelID,
    frameID,
    reference: [`ark:generated-${encodeURIComponent(panelID)}.opf`, '/6/2'],
    shouldNotifyContentSize: true,
    shouldApplyReflowableContentSettings: true,
  };

  const frameStore = getGlobalFrameStore();

  const onScaleApply = (
    visibleRect: Rectangle,
    visualScale: number,
    tabPanelAreaRect: Rectangle,
  ) => {
    const { width, height } = tabPanelAreaRect;
    frameStore.notifyVisualProperties(frameID, visibleRect, visualScale, { width, height }, false);
  };

  return (
    <SheetScaler
      behavior={ScaleBehavior.Transform}
      panelID={props.panelID}
      uiEventListeners={props.uiEventListeners}
      uimode={props.uimode}
      zoomingParams={arrangementInfo}
      onScaleApply={onScaleApply}>
      <PageIFrame
        width={arrangementInfo.containerWidth}
        height={arrangementInfo.blockFlowLength}
        style={defaultPageIFrameBackgrouncColor}
        pointerListeners={props.uiEventListeners}
        frameInfo={frameInfo}
        type="xhtml"
        content={props.xhtml} />
    </SheetScaler>
  );
});

const mapStateToProps = (state: AppStates, ownProps: GeneratedReflowablePageOwnProps) => (
  { ...mapStateToViewTransform(state, ownProps) }
);

export default connect(mapStateToProps)(GeneratedReflowablePage);
